import React, { useEffect, useState } from "react";
import { TableCell, TableRow } from "@mui/material";
import CheckRounded from "@mui/icons-material/CheckRounded";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { SupplierTypeEnum } from "@/main/services/enum/SupplierTypeEnum";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import SupplyConfigRegister from "./supplyConfigRegister";
import * as S from "./styles";
import { supplierTypeApi } from "@/main/api";
import { KeyValue } from "@/main/models/common";
import { SpinnerLoading } from "../styles";
import { SupplierType, SupplyConfigurationResponse } from "@/main/models/response";
import KogModalSideComponent from "../../modal/ModalSide";

export interface ISupplyConfigInfoState {
	guid: string;
	vehicleManufacturerName: string;
	registrationNumber: string;
	companyName: string;
	userDateTime: string;
}

interface Props {
	guidSupplierParams: string;
	supplyConfig: SupplyConfigurationResponse[];
	setSupplyConfig: React.Dispatch<React.SetStateAction<SupplyConfigurationResponse[]>>;
	watcherCountry?: KeyValue | null;
}

function SupplyConfig({ guidSupplierParams, supplyConfig, setSupplyConfig, watcherCountry }: Props) {
	const [open, setOpen] = useState<boolean>(false);
	const [isLoadingSupplierTypes, setIsLoadingSupplierTypes] = useState<boolean>(false);
	const [dataSupplierTypes, setDataSupplierTypes] = useState<KeyValue[]>([]);

	function openModal() {
		setOpen(true);
	}
	function closeModal() {
		setOpen(false);
	}

	async function getSupplierTypes() {
		setIsLoadingSupplierTypes(true);
		supplierTypeApi
			.getDomain()
			.then((response) => {
				setDataSupplierTypes(response.data.result);
			})
			.finally(() => {
				setIsLoadingSupplierTypes(false);
			});
	}

	useEffect(() => {
		getSupplierTypes();
	}, []);

	if (isLoadingSupplierTypes) return <SpinnerLoading />;

	const haveSupplierType = (supplierTypes: SupplierType[], idSupplierType: SupplierTypeEnum) =>
		supplierTypes.some((item) => item.idSupplierType === idSupplierType);
	const optionsSupplierTypes = dataSupplierTypes.map((supplierType) => supplierType.key);
	const rowHeadersSupplierTypes = dataSupplierTypes.map((supplierType) => supplierType.value);
	const rowHeaders = [getTranslateByKey("information.make"), ...rowHeadersSupplierTypes];
	const sizeColumnTypes = `${(50 / optionsSupplierTypes.length).toFixed(2)}%`;
	const rowHeadersFormatted = rowHeaders.map((header, index) => (
		<S.RowHeaderText key={index}>{header}</S.RowHeaderText>
	));

	return (
		<>
			<S.Container id="id-register-supplyConfig">
				<S.ContainerTitle>
					<S.HeaderText>{getTranslateByKey("supplyConfiguration.supplyConfiguration")}</S.HeaderText>
					<SecondaryButton
						style={{
							padding: ".2rem .8rem",
							marginTop: ".6rem",
						}}
						onClick={() => openModal()}
						id="id-registerSupplier-button-addEdit"
					>
						{`${getTranslateByKey("information.add")} / ${getTranslateByKey("information.edit")}`}
					</SecondaryButton>
				</S.ContainerTitle>
				{!isNullUndefined(supplyConfig) && supplyConfig.length > 0 && (
					<BoxGrid
						rowHeaders={rowHeadersFormatted}
						maxHeight={"390px"}
						textAlign="center"
						propsTable={{ stickyHeader: true }}
					>
						{supplyConfig.map((make) => (
							<TableRow key={make.vehicleManufacturer.guid}>
								<TableCell width="50%">{make.vehicleManufacturer.vehicleManufacturerName}</TableCell>
								{optionsSupplierTypes.map((option) => (
									<TableCell width={sizeColumnTypes} align="center" key={option}>
										{haveSupplierType(make.supplierTypes, Number(option)) && <CheckRounded />}
									</TableCell>
								))}
							</TableRow>
						))}
					</BoxGrid>
				)}
			</S.Container>
			<KogModalSideComponent
				open={open}
				shouldRenderOpen
				closeModal={() => closeModal()}
				titleModalReducer={getTranslateByKey("supplyConfiguration.supplyConfiguration")}
				width="830px"
				title={getTranslateByKey("supplyConfiguration.supplyConfiguration")}
			>
				{open && (
					<SupplyConfigRegister
						closeModal={() => closeModal()}
						guidSupplierParams={guidSupplierParams}
						setSupplyConfig={setSupplyConfig}
						watcherCountry={watcherCountry}
						dataSupplierTypes={dataSupplierTypes}
						sizeColumnTypes={sizeColumnTypes}
					/>
				)}
			</KogModalSideComponent>
		</>
	);
}

export default SupplyConfig;
